__turbopack_context__.v({
  "product": "product-module-scss-module__xU9Vza__product",
});
